var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
const MoreInfo = (_a) => {
    var { color = "#00A3FF", width = 14, height = 14, fillOpacity = '1' } = _a, props = __rest(_a, ["color", "width", "height", "fillOpacity"]);
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M6.33398 3.66671H7.66732V5.00004H6.33398V3.66671ZM6.33398 6.33337H7.66732V10.3334H6.33398V6.33337ZM7.00065 0.333374C3.32065 0.333374 0.333984 3.32004 0.333984 7.00004C0.333984 10.68 3.32065 13.6667 7.00065 13.6667C10.6807 13.6667 13.6673 10.68 13.6673 7.00004C13.6673 3.32004 10.6807 0.333374 7.00065 0.333374ZM7.00065 12.3334C4.06065 12.3334 1.66732 9.94004 1.66732 7.00004C1.66732 4.06004 4.06065 1.66671 7.00065 1.66671C9.94065 1.66671 12.334 4.06004 12.334 7.00004C12.334 9.94004 9.94065 12.3334 7.00065 12.3334Z", fill: color })));
};
export default MoreInfo;
